module.exports = __webpack_public_path__ + "img/6.7f0d6771.png";